module.exports = __webpack_public_path__ + "static/media/rakuten.eb1b2af7.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/imgs/channel/rakuten.png
// module id = 420
// module chunks = 0